import styled from 'styled-components'
import { theme } from '@/client/components'
const { borders, color, font, space, breakpoint } = theme

export const Finishing = styled.div`
  padding-bottom: ${space.xl2};

  &:nth-child(odd) {
    background-color: ${color.grayscale.lighter};
  }

  &:not(:nth-child(2)) {
    padding-top: ${space.xl2};
  }

  &:last-of-type {
    background-color: ${color.grayscale.white};
    border-top: ${borders.sizes.md} dashed ${color.grayscale.light};
  }

  @media (min-width: ${breakpoint.xl}) {
    padding: ${space.xl3} 0 ${space.xl4};
  }
`

export const ContentInfos = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${breakpoint.xl}) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }
`

export const ContentLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  order: 2;
  width: 100%;

  @media (min-width: ${breakpoint.xl}) {
    order: 1;
    width: 60%;
  }
`

export const Button = styled.a`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: ${space.xl2};
  padding: 0 ${space.md};
  margin-bottom: ${space.xl};
  border-radius: ${borders.sizes.xl};
  border: ${borders.sizes.md} solid ${color.primary.light};
  gap: ${space.xs};
  background-color: ${color.primary.light};
  color: ${color.primary.darker};
  font-size: ${font.size.xsmall};
  font-weight: ${font.weight.medium};
  line-height: ${font.lineHeight.sm};
  transition: all 0.3s ease;

  &:hover {
    text-decoration: none;
  }

  @media (min-width: ${breakpoint.lg}) {
    border-color: ${color.grayscale.light};
    background-color: transparent;

    &:hover {
      border-color: ${color.primary.light};
      background-color: ${color.primary.light};
    }
  }
`

export const ContentRight = styled.div`
  order: 1;
  width: 100%;
  max-width: 30rem;
  align-self: center;
  margin-bottom: ${space.xl2};
  border-radius: ${borders.radius.xl};
  overflow: hidden;
  border-color: transparent;

  @media (min-width: ${breakpoint.xl}) {
    order: 2;
    width: 35%;
    margin-bottom: 0;
    align-self: flex-start;
  }

  img {
    display: block;
    width: 100%;
    height: auto;
  }
`
